// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.login_bodic__f44Bi {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 90vh;
}

.login_wrap__cFUl- {
  max-width: 420px;
  width: 100%;
  background: transparent;
  border: 2px solid #111;
  border-radius: 20px;
  box-shadow: 10px 10px 8px #111;
  padding: 30px 40px;
}
.login_wrap__cFUl- h1 {
  font-size: 36px;
  text-align: center;
  color: #111;
}

.login_wrap__cFUl- .login_input-box__6H6aw {
  position: relative;
  width: 100%;
  height: 50px;
  margin: 20px 0;
}

.login_wrap-username__qZtZF,
.login_wrap-password__GddXw,
.login_wrap-email__EZsD4,
.login_wrap-fullname__QDcAf {
  background: transparent;
  width: 100%;
  height: 100%;
  padding: 20px 45px 20px 20px;
  border: 2px solid rgba(230, 226, 226, 0.9);
  border-radius: 40px;
  color: #111;
  outline: none;
  font-size: 1.4rem;
}
.login_wrap-username__qZtZF::placeholder,
.login_wrap-password__GddXw::placeholder,
.login_wrap-email__EZsD4::placeholder,
.login_wrap-fullname__QDcAf::placeholder {
  opacity: 0.7;
}
.login_wrap-username__qZtZF:focus::placeholder,
.login_wrap-password__GddXw:focus::placeholder,
.login_wrap-email__EZsD4:focus::placeholder,
.login_wrap-fullname__QDcAf:focus::placeholder {
  font-weight: bold; /* Đậm hơn */
  opacity: 0.9;
}
.login_wrap-username__qZtZF:focus,
.login_wrap-password__GddXw:focus,
.login_wrap-email__EZsD4:focus,
.login_wrap-fullname__QDcAf:focus {
  outline: none;
  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.3) !important;
  border-color: #6c757d;
}

.login_input-box__6H6aw input::placeholder {
  color: #111;
  font-weight: 500;
}

.login_input-box__6H6aw i {
  color: #111;
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 15px;
}

.login_wrap__cFUl- .login_remember-forgot__Sc\\+J4 {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  margin: 0 15px 10px 15px;
}

.login_wrap__cFUl- .login_remember-forgot__register__PcQRS {
  color: #111;
  margin: 0 10px 10px 10px;
  font-size: 16px;
}

.login_remember-forgot__Sc\\+J4 label {
  margin-right: 5px;
  display: flex;
  align-items: center;
}
.login_remember-forgot__Sc\\+J4 input {
  margin-right: 5px;
}
.login_remember-forgot__Sc\\+J4 a {
  color: #111;
  font-weight: bold;
}

.login_remember-login__Mc\\+r0 {
  display: flex;
  justify-content: end;
  align-items: center;
  color: #111;
  font-weight: bold;
  margin: 0 10px 10px 0;
}

.login_login-btn__Z8W9j {
  width: 100%;
  height: 45px;
  background: #fff;
  border-radius: 30px;
  cursor: pointer;
  border: none;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  font-size: 16px;
  color: #111;
  font-weight: 600;
  transition: background-color 0.3s ease;
}
.login_login-btn__Z8W9j:hover {
  background-color: black;
  color: #fff;
}

.login_login-message__Xe6gW {
  font-size: 1.4rem;
  padding: 10px 0;
  color: red;
}

.login_register-link__a5Ywz {
  font-size: 15px;
  text-align: center;
  margin: 20px 0 15px 0;
  color: #111;
}
.login_register-link__a5Ywz a {
  color: #111;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/pages/user/login/login.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAEJ;;AACE;EACE,gBAAA;EACA,WAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;EAEA,kBAAA;AACJ;AACI;EACI,eAAA;EACA,kBAAA;EACA,WAAA;AACR;;AAGE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAAJ;;AAGE;;;;EAIE,uBAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,0CAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,iBAAA;AAAJ;AACI;;;;EACE,YAAA;AAIN;AAFI;;;;EACE,iBAAA,EAAA,YAAA;EACA,YAAA;AAON;AALI;;;;EACE,aAAA;EACA,4DAAA;EACA,qBAAA;AAUN;;AANE;EACE,WAAA;EACA,gBAAA;AASJ;;AANE;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;AASJ;;AANE;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,wBAAA;AASJ;;AANE;EACE,WAAA;EACA,wBAAA;EACA,eAAA;AASJ;;AALI;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;AAQJ;AALI;EACI,iBAAA;AAOR;AALI;EACI,WAAA;EACA,iBAAA;AAOR;;AAHE;EACE,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;AAMJ;;AADE;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,uCAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,sCAAA;AAIJ;AAFI;EACI,uBAAA;EACA,WAAA;AAIR;;AAAE;EACE,iBAAA;EACA,eAAA;EACA,UAAA;AAGJ;;AAAE;EACE,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;AAGJ;AADI;EACI,WAAA;EACA,iBAAA;AAGR","sourcesContent":[".bodic {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 90vh;\n  }\n  \n  .wrap {\n    max-width: 420px;\n    width: 100%;\n    background: transparent;\n    border: 2px solid #111;\n    border-radius: 20px;\n    box-shadow: 10px 10px 8px #111;\n\n    padding: 30px 40px;\n\n    h1 {\n        font-size: 36px;\n        text-align: center;\n        color: #111;\n      }\n  }\n  \n  .wrap .input-box {\n    position: relative;\n    width: 100%;\n    height: 50px;\n    margin: 20px 0;\n  }\n  \n  .wrap-username,\n  .wrap-password,\n  .wrap-email,\n  .wrap-fullname {\n    background: transparent;\n    width: 100%;\n    height: 100%;\n    padding: 20px 45px 20px 20px;\n    border: 2px solid rgba(230, 226, 226, 0.9);\n    border-radius: 40px;\n    color: #111;\n    outline: none;\n    font-size: 1.4rem;\n    &::placeholder{\n      opacity: 0.7;\n    }\n    &:focus::placeholder {\n      font-weight: bold; /* Đậm hơn */\n      opacity: 0.9;\n  }\n    &:focus{\n      outline: none;\n      box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.3) !important; \n      border-color: #6c757d;\n}\n  }\n  \n  .input-box input::placeholder {\n    color: #111;\n    font-weight: 500;\n  }\n  \n  .input-box i {\n    color: #111;\n    position: absolute;\n    right: 15px;\n    top: 50%;\n    transform: translateY(-50%);\n    font-size: 15px;\n  }\n  \n  .wrap .remember-forgot {\n    display: flex;\n    justify-content: space-between;\n    font-size: 16px;\n    margin: 0 15px 10px 15px;\n  }\n  \n  .wrap .remember-forgot__register {\n    color: #111;\n    margin: 0 10px 10px 10px;\n    font-size: 16px;\n  }\n  \n  .remember-forgot{\n    label{\n    margin-right: 5px;\n    display: flex;\n    align-items: center;\n    }\n\n    input{\n        margin-right: 5px;\n    }\n    a {\n        color: #111;\n        font-weight: bold;\n    }\n  }\n\n  .remember-login{\n    display: flex;\n    justify-content: end;\n    align-items: center;\n    color: #111;\n    font-weight: bold;\n    margin:0 10px 10px 0\n\n  }\n  \n    \n  .login-btn {\n    width: 100%;\n    height: 45px;\n    background: #fff;\n    border-radius: 30px;\n    cursor: pointer;\n    border: none;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n    font-size: 16px;\n    color: #111;\n    font-weight: 600;\n    transition: background-color 0.3s ease;\n\n    &:hover{\n        background-color: black;\n        color: #fff;\n\n    }\n  }\n  .login-message{\n    font-size: 1.4rem;\n    padding: 10px 0;\n    color: red;\n  }\n   \n  .register-link {\n    font-size: 15px;\n    text-align: center;\n    margin: 20px 0 15px 0;\n    color: #111;\n\n    a {\n        color: #111;\n        font-weight: bold;\n      }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bodic": `login_bodic__f44Bi`,
	"wrap": `login_wrap__cFUl-`,
	"input-box": `login_input-box__6H6aw`,
	"wrap-username": `login_wrap-username__qZtZF`,
	"wrap-password": `login_wrap-password__GddXw`,
	"wrap-email": `login_wrap-email__EZsD4`,
	"wrap-fullname": `login_wrap-fullname__QDcAf`,
	"remember-forgot": `login_remember-forgot__Sc+J4`,
	"remember-forgot__register": `login_remember-forgot__register__PcQRS`,
	"remember-login": `login_remember-login__Mc+r0`,
	"login-btn": `login_login-btn__Z8W9j`,
	"login-message": `login_login-message__Xe6gW`,
	"register-link": `login_register-link__a5Ywz`
};
export default ___CSS_LOADER_EXPORT___;
